import { Settings, Paintbrush, Palette, ChevronRight, ChevronLeft } from "lucide-react";
import { useEditorStore, type InspectorTab } from "../store";
import { InspectorContent } from "./InspectorContent";
import { InspectorStyle } from "./InspectorStyle";
import { InspectorTheme } from "./InspectorTheme";
import { findNodeById } from "../tree-utils";

const TABS: { id: InspectorTab; label: string; icon: typeof Settings }[] = [
  { id: "content", label: "Content", icon: Settings },
  { id: "style", label: "Style", icon: Paintbrush },
  { id: "theme", label: "Theme", icon: Palette },
];

export function RightInspector() {
  const document = useEditorStore((s) => s.document);
  const selectedNodeId = useEditorStore((s) => s.selectedNodeId);
  const inspectorTab = useEditorStore((s) => s.inspectorTab);
  const setInspectorTab = useEditorStore((s) => s.setInspectorTab);
  const width = useEditorStore((s) => s.rightSidebarWidth);
  const isCollapsed = useEditorStore((s) => s.rightSidebarCollapsed);
  const toggleRightSidebar = useEditorStore((s) => s.toggleRightSidebar);

  const selectedNode = selectedNodeId ? findNodeById(document, selectedNodeId)?.node : null;
  const isSection = selectedNode?.type === "Section";

  if (isCollapsed) {
    return (
      <aside className="zirro-right zirro-right--collapsed" aria-label="Inspector (collapsed)">
        <button
          type="button"
          className="zirro-right__expand-btn"
          onClick={toggleRightSidebar}
          title="Expand Inspector"
          aria-label="Expand Inspector"
        >
          <ChevronLeft size={16} />
        </button>
      </aside>
    );
  }

  return (
    <aside className="zirro-right" style={{ width: `${width}px` }} aria-label="Inspector">
      <div className="zirro-right__tabs" role="tablist">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const label = isSection && tab.id === "content" ? "Section" : tab.label;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              className={`zirro-right__tab-btn ${inspectorTab === tab.id ? "zirro-right__tab-btn--active" : ""}`}
              aria-selected={inspectorTab === tab.id}
              onClick={() => setInspectorTab(tab.id)}
            >
              <Icon size={14} />
              {label}
            </button>
          );
        })}
        <button
          type="button"
          className="zirro-right__tab-btn zirro-right__tab-btn--collapse"
          onClick={toggleRightSidebar}
          title="Collapse Inspector"
          aria-label="Collapse Inspector"
          style={{ flex: "0 0 auto", padding: "10px 8px" }}
        >
          <ChevronRight size={14} />
        </button>
      </div>

      <div className="zirro-right__body">
        {inspectorTab === "content" ? <InspectorContent /> : null}
        {inspectorTab === "style" ? <InspectorStyle /> : null}
        {inspectorTab === "theme" ? <InspectorTheme /> : null}
      </div>
    </aside>
  );
}
